export const Settings = {
    dateFormat: "dd-MMM-yyyy",
    timeFormat: 'hh:mm a',
    calendarDateFormat: "dd-M-yy",
    dateTimeformat: "dd-MMM-yyyy hh:mm a",
    HourFormat: "hh:mm",
    monthDateFormat: "MMM-yyyy",
    monthPickerFormat:"M-yy",
    InOutHourFormat:"HH:mm",
    birthDateFormat:"dd-MMM'",
    offerletterDateFormat:"dd MMMM yyyy",
    date: 'dd',
    day: 'EEE',
    salarySlipFormat:'MMM, YYYY'
}